(function (global) {
  'use strict';

  var MASTER_NUMBERS = { 11: true, 22: true, 33: true };
  var KARMIC_DEBTS = { 13: true, 14: true, 16: true, 19: true };
  var NUMBER_MEANINGS = {
    1: { title: 'The Initiator', text: 'Independent direction, beginnings and the discipline of acting from your own authority.' },
    2: { title: 'The Diplomat', text: 'Cooperation, sensitivity and the ability to notice what a relationship or decision needs.' },
    3: { title: 'The Communicator', text: 'Expression, imagination and the need to give creative energy a clear container.' },
    4: { title: 'The Builder', text: 'Structure, reliability and progress created through repeatable practical steps.' },
    5: { title: 'The Explorer', text: 'Change, adaptability and freedom strengthened by conscious commitments.' },
    6: { title: 'The Steward', text: 'Care, responsibility and the lesson of helping without carrying everything alone.' },
    7: { title: 'The Seeker', text: 'Analysis, inner depth and the search for evidence beneath first appearances.' },
    8: { title: 'The Strategist', text: 'Power, resources and the ethical use of ambition, boundaries and leadership.' },
    9: { title: 'The Humanitarian', text: 'Perspective, completion and contribution that extends beyond personal gain.' },
    11: { title: 'The Illuminator', text: 'A master-number pattern of heightened perception that becomes useful when insight is grounded.' },
    22: { title: 'The Master Builder', text: 'A master-number pattern that joins large vision with systems capable of making it real.' },
    33: { title: 'The Master Teacher', text: 'A master-number pattern of compassionate service that still requires sustainable limits.' }
  };
  var ARCANA = {
    1: ['The Magician', 'initiative and directed skill'], 2: ['The High Priestess', 'discernment and inner knowledge'],
    3: ['The Empress', 'creation and nourishment'], 4: ['The Emperor', 'structure and authority'],
    5: ['The Hierophant', 'values and inherited frameworks'], 6: ['The Lovers', 'alignment and consequential choice'],
    7: ['The Chariot', 'will, direction and self-command'], 8: ['Strength', 'courage and regulated power'],
    9: ['The Hermit', 'solitude, study and perspective'], 10: ['Wheel of Fortune', 'cycles and changing conditions'],
    11: ['Justice', 'balance, truth and accountability'], 12: ['The Hanged Man', 'pause and a changed point of view'],
    13: ['Death', 'closure and transformation'], 14: ['Temperance', 'integration and proportion'],
    15: ['The Devil', 'attachment and conscious agency'], 16: ['The Tower', 'disruption and necessary truth'],
    17: ['The Star', 'renewal and honest hope'], 18: ['The Moon', 'uncertainty and intuitive testing'],
    19: ['The Sun', 'clarity and visible vitality'], 20: ['Judgement', 'review and a decisive awakening'],
    21: ['The World', 'completion and integrated experience'], 22: ['The Fool', 'openness, risk and a new cycle']
  };
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function sumDigits(value) {
    return String(Math.abs(Number(value) || 0)).split('').reduce(function (total, digit) { return total + Number(digit); }, 0);
  }
  function isMaster(value) { return MASTER_NUMBERS[value] === true; }
  function reductionTrace(value, preserveMasters) {
    var number = Math.abs(parseInt(value, 10) || 0);
    var stages = [number];
    while (number > 9 && !(preserveMasters !== false && isMaster(number))) {
      number = sumDigits(number);
      stages.push(number);
    }
    var debtCompound = stages.filter(function (stage) { return KARMIC_DEBTS[stage] === true; })[0];
    return {
      raw: stages[0],
      value: number,
      compound: debtCompound || stages[0],
      stages: stages
    };
  }
  function reduceNumber(value) { return reductionTrace(value, true).value; }
  function normalizeName(value) {
    var normalized = String(value || '');
    if (typeof normalized.normalize === 'function') normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    normalized = normalized
      .replace(/[Łł]/g, 'L').replace(/[ĐðÐ]/g, 'D').replace(/[Þþ]/g, 'TH')
      .replace(/[Ææ]/g, 'AE').replace(/[Œœ]/g, 'OE').replace(/[ß]/g, 'SS')
      .toUpperCase().replace(/[^A-Z' -]/g, ' ').replace(/['-]+/g, ' ')
      .replace(/\s+/g, ' ').trim();
    return { display: normalized, letters: normalized.replace(/[^A-Z]/g, '') };
  }
  function letterValue(letter) {
    var code = String(letter || '').charCodeAt(0) - 64;
    return code >= 1 && code <= 26 ? ((code - 1) % 9) + 1 : 0;
  }
  function calculateName(value) {
    var normalized = normalizeName(value);
    var all = 0, vowels = 0, consonants = 0;
    for (var index = 0; index < normalized.letters.length; index += 1) {
      var letter = normalized.letters.charAt(index);
      var amount = letterValue(letter);
      all += amount;
      if ('AEIOU'.indexOf(letter) >= 0) vowels += amount;
      else consonants += amount;
    }
    return {
      normalized: normalized.display,
      letters: normalized.letters.length,
      expression: reductionTrace(all, true),
      soulUrge: reductionTrace(vowels, true),
      personality: reductionTrace(consonants, true)
    };
  }
  function calculateLifePath(year, month, day) {
    var monthPart = reductionTrace(month, true);
    var dayPart = reductionTrace(day, true);
    var yearPart = reductionTrace(year, true);
    var total = monthPart.value + dayPart.value + yearPart.value;
    var finalPart = reductionTrace(total, true);
    return { month: monthPart, day: dayPart, year: yearPart, total: total, final: finalPart, value: finalPart.value };
  }
  function calculateNameBlueprint(name, year, month, day) {
    var profile = calculateName(name);
    var path = calculateLifePath(year, month, day);
    return {
      normalized: profile.normalized,
      letters: profile.letters,
      lifePath: path,
      expression: profile.expression,
      soulUrge: profile.soulUrge,
      personality: profile.personality,
      birthday: reductionTrace(day, true)
    };
  }
  function calculatePersonalYear(year, month, day, targetYear) {
    var birthMonth = reductionTrace(month, true);
    var birthDay = reductionTrace(day, true);
    var universalYear = reductionTrace(targetYear, true);
    var total = birthMonth.value + birthDay.value + universalYear.value;
    var personalYear = reductionTrace(total, true);
    var months = [];
    for (var calendarMonth = 1; calendarMonth <= 12; calendarMonth += 1) {
      months.push(reductionTrace(personalYear.value + calendarMonth, true).value);
    }
    return {
      birthMonth: birthMonth,
      birthDay: birthDay,
      universalYear: universalYear,
      total: total,
      personalYear: personalYear,
      lifePath: calculateLifePath(year, month, day),
      months: months
    };
  }
  function debtStages(trace) {
    return trace.stages.filter(function (stage, index, stages) { return KARMIC_DEBTS[stage] && stages.indexOf(stage) === index; });
  }
  function calculateKarmicDebt(name, year, month, day) {
    var path = calculateLifePath(year, month, day);
    var profile = String(name || '').trim() ? calculateName(name) : null;
    var findings = [];
    if (KARMIC_DEBTS[day]) findings.push({ number: day, position: 'Birth Day' });
    debtStages(path.final).forEach(function (number) { findings.push({ number: number, position: 'Life Path reduction' }); });
    if (profile) debtStages(profile.expression).forEach(function (number) { findings.push({ number: number, position: 'Expression reduction' }); });
    var unique = [];
    findings.forEach(function (finding) {
      var key = finding.number + '|' + finding.position;
      if (!unique.some(function (item) { return item.key === key; })) unique.push({ key: key, number: finding.number, position: finding.position });
    });
    return { lifePath: path, name: profile, birthday: day, findings: unique };
  }
  function arcanaReduce(value) {
    var number = Math.abs(parseInt(value, 10) || 0);
    while (number > 22) number = sumDigits(number);
    return number || 22;
  }
  function calculateDestinyMatrix(year, month, day) {
    var dayEnergy = arcanaReduce(day);
    var monthEnergy = arcanaReduce(month);
    var yearEnergy = arcanaReduce(sumDigits(year));
    var coreEnergy = arcanaReduce(dayEnergy + monthEnergy + yearEnergy);
    var love = arcanaReduce(dayEnergy + coreEnergy);
    var money = arcanaReduce(monthEnergy + coreEnergy);
    var talent = arcanaReduce(yearEnergy + coreEnergy);
    var tailA = arcanaReduce(dayEnergy + monthEnergy);
    var tailB = arcanaReduce(monthEnergy + yearEnergy);
    var tailC = arcanaReduce(tailA + tailB);
    return {
      day: dayEnergy, month: monthEnergy, year: yearEnergy, core: coreEnergy,
      love: love, money: money, talent: talent, tail: [tailA, tailB, tailC]
    };
  }

  var MathApi = {
    sumDigits: sumDigits,
    reductionTrace: reductionTrace,
    reduceNumber: reduceNumber,
    normalizeName: normalizeName,
    calculateName: calculateName,
    calculateLifePath: calculateLifePath,
    calculateNameBlueprint: calculateNameBlueprint,
    calculatePersonalYear: calculatePersonalYear,
    calculateKarmicDebt: calculateKarmicDebt,
    arcanaReduce: arcanaReduce,
    calculateDestinyMatrix: calculateDestinyMatrix
  };
  global.DeckauraNumerologyDestinyMath = MathApi;
  if (!global.document) return;

  function create(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }
  function clear(node) { while (node && node.firstChild) node.removeChild(node.firstChild); }
  function displayTrace(trace) { return trace.stages.join(' → '); }
  function numberMeaning(value) { return NUMBER_MEANINGS[value] || NUMBER_MEANINGS[reduceNumber(value)] || NUMBER_MEANINGS[1]; }
  function arcana(value) { return ARCANA[value] || ARCANA[22]; }
  function isoDate(parts) {
    return String(parts.year).padStart(4, '0') + '-' + String(parts.month).padStart(2, '0') + '-' + String(parts.day).padStart(2, '0');
  }
  function parseDate(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
    if (!match) return null;
    var parts = { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
    var test = new Date(parts.year, parts.month - 1, parts.day);
    if (test.getFullYear() !== parts.year || test.getMonth() !== parts.month - 1 || test.getDate() !== parts.day) return null;
    var today = new Date(); today.setHours(23, 59, 59, 999);
    if (parts.year < 1900 || test > today) return null;
    return parts;
  }
  function readingId(prefix) {
    try { if (global.crypto && typeof global.crypto.randomUUID === 'function') return global.crypto.randomUUID(); } catch (_) {}
    return prefix + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 11);
  }

  function setup(root) {
    if (root.getAttribute('data-ndc-ready') === 'true') return;
    root.setAttribute('data-ndc-ready', 'true');
    var tool = root.getAttribute('data-ndc-tool') || '';
    var nameI18n = {};
    if (tool === 'name-numerology') {
      try {
        var nameI18nNode = root.querySelector('[data-ndc-name-i18n]');
        if (nameI18nNode) nameI18n = JSON.parse(nameI18nNode.textContent || '{}') || {};
      } catch (_) { nameI18n = {}; }
    }
    function nameText(key, fallback) {
      return typeof nameI18n[key] === 'string' && nameI18n[key] ? nameI18n[key] : fallback;
    }
    function nameTemplate(key, fallback, values) {
      return nameText(key, fallback).replace(/\{(\w+)\}/g, function (_, token) {
        return Object.prototype.hasOwnProperty.call(values, token) ? String(values[token]) : '';
      });
    }
    function localizedNameMeaning(value) {
      var resolved = NUMBER_MEANINGS[value] ? value : reduceNumber(value);
      return nameText('meaning' + resolved, numberMeaning(value).title);
    }
    var form = root.querySelector('[data-ndc-form]');
    var result = root.querySelector('[data-ndc-result]');
    var resultTitle = root.querySelector('[data-ndc-result-title]');
    var resultNote = root.querySelector('[data-ndc-result-note]');
    var scores = root.querySelector('[data-ndc-scores]');
    var insights = root.querySelector('[data-ndc-insights]');
    var math = root.querySelector('[data-ndc-math]');
    var months = root.querySelector('[data-ndc-months]');
    var debts = root.querySelector('[data-ndc-debts]');
    var matrix = root.querySelector('[data-ndc-matrix]');
    var offer = root.querySelector('[data-ndc-offer]');
    var error = root.querySelector('[data-ndc-error]');
    var reset = root.querySelector('[data-ndc-reset]');
    var share = root.querySelector('[data-ndc-share]');
    var shareStatus = root.querySelector('[data-ndc-share-status]');
    var currentShareText = '';

    function field(name) { return form.querySelector('[data-ndc-field="' + name + '"]'); }
    function invalidate(input, message) {
      error.textContent = message;
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }
    function clearErrors() {
      error.textContent = '';
      Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid="true"]'), function (input) { input.removeAttribute('aria-invalid'); });
    }
    function score(label, value, caption) {
      var card = create('article', 'ndc__score');
      card.appendChild(create('span', '', label));
      card.appendChild(create('strong', '', value));
      card.appendChild(create('small', '', caption));
      scores.appendChild(card);
    }
    function insight(title, copy) {
      var card = create('article', 'ndc__insight');
      card.appendChild(create('h3', '', title));
      card.appendChild(create('p', '', copy));
      insights.appendChild(card);
    }
    function beginResult(title, note) {
      clear(scores); clear(insights); clear(math); clear(months); clear(debts); clear(matrix);
      scores.hidden = true; insights.hidden = true; math.hidden = true; months.hidden = true; debts.hidden = true; matrix.hidden = true;
      resultTitle.textContent = title;
      resultNote.textContent = note;
      result.hidden = false;
      offer.hidden = false;
      if (share) share.hidden = tool !== 'destiny-matrix';
      if (shareStatus) shareStatus.textContent = '';
    }
    function show(node) { node.hidden = false; }
    function reveal() {
      result.focus({ preventScroll: true });
      var reduceMotion = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
      result.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
    function focusValue() {
      var focus = field('focus');
      return focus ? String(focus.value || 'Overall pattern').slice(0, 160) : 'Overall pattern';
    }
    function configureOffer(config) {
      var api = global.DeckauraDeepReading;
      if (!api || typeof api.enable !== 'function') return;
      api.enable({
        type: config.type,
        question: config.question,
        context: config.context,
        signals: config.signals,
        scope: config.scope,
        confidence: config.confidence,
        focus: focusValue(),
        fixedFocus: focusValue(),
        tool: config.tool,
        readingId: readingId(config.prefix),
        curiosityQuestion: config.question,
        lang: (document.documentElement && document.documentElement.lang) || 'en',
        resultReady: true,
        requireContext: false,
        teaser: false,
        allowedTiers: ['deeper', 'indepth'],
        defaultTier: 'deeper'
      });
    }
    function scrubInputs() {
      var nameInput = field('birth_name');
      var dateInput = field('birth_date');
      if (nameInput) nameInput.value = '';
      if (dateInput) dateInput.value = '';
    }

    function renderName(name, birth) {
      var profile = calculateNameBlueprint(name, birth.year, birth.month, birth.day);
      if (profile.letters < 2) { invalidate(field('birth_name'), nameText('errorName', 'Enter at least two letters from your full birth name.')); return false; }
      var lifeLabel = nameText('labelLife', 'Life Path');
      var expressionLabel = nameText('labelExpression', 'Expression Number');
      var soulLabel = nameText('labelSoul', 'Soul Urge Number');
      var personalityLabel = nameText('labelPersonality', 'Personality Number');
      var birthdayLabel = nameText('labelBirthday', 'Birthday Number');
      beginResult(nameText('resultTitle', 'Your five core numerology numbers'), nameText('resultNote', 'Each score is calculated locally from the exact name and birth date you entered.'));
      [
        [lifeLabel, profile.lifePath.value, localizedNameMeaning(profile.lifePath.value)],
        [expressionLabel, profile.expression.value, localizedNameMeaning(profile.expression.value)],
        [soulLabel, profile.soulUrge.value, localizedNameMeaning(profile.soulUrge.value)],
        [personalityLabel, profile.personality.value, localizedNameMeaning(profile.personality.value)],
        [birthdayLabel, profile.birthday.value, localizedNameMeaning(profile.birthday.value)]
      ].forEach(function (item) { score(item[0], item[1], item[2]); });
      show(scores);
      insight(nameText('directionTitle', 'Your central direction'), nameTemplate('directionTemplate', 'Life Path {life} meets Expression {expression}. {meaning}', {
        life: profile.lifePath.value, expression: profile.expression.value, meaning: localizedNameMeaning(profile.lifePath.value)
      }));
      insight(nameText('motivationTitle', 'How your motivation meets the world'), nameTemplate('motivationTemplate', 'Soul Urge {soul} describes the private motive; Personality {personality} describes the first pattern others are more likely to notice.', {
        soul: profile.soulUrge.value, personality: profile.personality.value
      }));
      insight(nameText('tensionTitle', 'The useful tension'), nameText('tensionText', 'When two scores point in different directions, treat that contrast as a reflective prompt rather than a flaw or prediction.'));
      var focusField = field('focus');
      var visibleFocus = focusField && focusField.options && focusField.selectedIndex >= 0 ? focusField.options[focusField.selectedIndex].textContent.trim() : focusValue();
      insight(nameText('nextTitle', 'A grounded next step'), nameTemplate('nextTemplate', 'Use your Birthday {birthday} as a supporting skill while you test one choice related to {focus}.', {
        birthday: profile.birthday.value, focus: visibleFocus.toLocaleLowerCase()
      }));
      show(insights);
      math.textContent = lifeLabel + ': ' + profile.lifePath.month.value + ' + ' + profile.lifePath.day.value + ' + ' + profile.lifePath.year.value + ' = ' + profile.lifePath.total + ' → ' + profile.lifePath.value + '. ' + expressionLabel + ': ' + displayTrace(profile.expression) + '. ' + soulLabel + ': ' + displayTrace(profile.soulUrge) + '. ' + personalityLabel + ': ' + displayTrace(profile.personality) + '.';
      show(math);
      var dob = isoDate(birth);
      configureOffer({
        type: 'Numerology Blueprint', tool: '/pages/name-numerology-calculator', prefix: 'nb',
        question: 'How do my five core numerology numbers work together in ' + focusValue().toLowerCase() + ', and what grounded next step follows?',
        context: 'Calculation input: normalized birth name <' + profile.normalized + '>; birth date ' + dob + '. Method: Pythagorean letter values; master numbers 11, 22, and 33 preserved during final reductions.',
        signals: [
          { label: 'Life Path', value: String(profile.lifePath.value) },
          { label: 'Expression', value: String(profile.expression.value) },
          { label: 'Soul Urge', value: String(profile.soulUrge.value) },
          { label: 'Personality', value: String(profile.personality.value) },
          { label: 'Birthday', value: String(profile.birthday.value) }
        ],
        scope: 'A synthesis of the five deterministic Pythagorean numerology scores shown above, applied to the selected focus with practical reflection prompts.',
        confidence: 'Deterministic symbolic calculation; numerology is not scientifically validated.'
      });
      scrubInputs();
      reveal();
      return true;
    }

    function renderPersonalYear(birth, targetYear) {
      var cycle = calculatePersonalYear(birth.year, birth.month, birth.day, targetYear);
      var meaning = numberMeaning(cycle.personalYear.value);
      beginResult('Your ' + targetYear + ' Personal Year is ' + cycle.personalYear.value, meaning.title + ': ' + meaning.text);
      score('Personal Year', cycle.personalYear.value, meaning.title);
      score('Life Path', cycle.lifePath.value, numberMeaning(cycle.lifePath.value).title);
      score('Universal Year', cycle.universalYear.value, targetYear + ' collective tone');
      score('Birthday', cycle.birthDay.value, 'Your recurring gift');
      show(scores);
      insight('Theme of the year', meaning.text);
      insight('How to use it', 'A Personal Year describes a symbolic cycle, not a deadline. Use it to choose experiments and review points for ' + focusValue().toLowerCase() + '.');
      show(insights);
      cycle.months.forEach(function (value, index) {
        var card = create('div', 'ndc__month');
        card.appendChild(create('span', '', MONTHS[index]));
        card.appendChild(create('strong', '', value));
        months.appendChild(card);
      });
      show(months);
      math.textContent = 'Birth month ' + birth.month + ' → ' + cycle.birthMonth.value + '; birth day ' + birth.day + ' → ' + cycle.birthDay.value + '; universal year ' + targetYear + ' → ' + cycle.universalYear.value + '; total ' + cycle.total + ' → Personal Year ' + cycle.personalYear.value + '.';
      show(math);
      var dob = isoDate(birth);
      configureOffer({
        type: 'Personal Year Numerology', tool: '/pages/personal-year-calculator', prefix: 'py',
        question: 'How should I work with Personal Year ' + cycle.personalYear.value + ' for ' + focusValue().toLowerCase() + ' during ' + targetYear + '?',
        context: 'Calculation input: birth date ' + dob + '; target year ' + targetYear + '. Method: reduced birth month + reduced birth day + reduced universal year; master numbers 11, 22, and 33 preserved.',
        signals: [
          { label: 'Personal Year', value: String(cycle.personalYear.value) },
          { label: 'Target Year', value: String(targetYear) },
          { label: 'Universal Year', value: String(cycle.universalYear.value) },
          { label: 'Life Path', value: String(cycle.lifePath.value) }
        ],
        scope: 'A timing-focused numerology reflection for the selected target year, including its month sequence, priorities, cautions and practical planning prompts.',
        confidence: 'Deterministic symbolic calculation; timing themes are reflective, not predictive.'
      });
      scrubInputs();
      reveal();
      return true;
    }

    var DEBT_COPY = {
      13: '13/4 is commonly read as a lesson in steady effort, realistic structure and replacing shortcuts with repeatable practice.',
      14: '14/5 is commonly read as a lesson in freedom with proportion, especially around excess, inconsistency and commitment.',
      16: '16/7 is commonly read as a lesson in humility, truth-testing and rebuilding identity after an assumption changes.',
      19: '19/1 is commonly read as a lesson in independent action that does not dismiss cooperation, reciprocity or support.'
    };
    function renderKarmic(name, birth) {
      var audit = calculateKarmicDebt(name, birth.year, birth.month, birth.day);
      if (String(name || '').trim() && (!audit.name || audit.name.letters < 2)) { invalidate(field('birth_name'), 'Use at least two letters, or leave the optional birth-name field blank.'); return false; }
      var summary = audit.findings.length ? audit.findings.map(function (item) { return item.number; }).filter(function (number, index, all) { return all.indexOf(number) === index; }).join(', ') : 'No marker in checked positions';
      beginResult(audit.findings.length ? 'Your checked Karmic Debt markers' : 'No Karmic Debt marker appeared in the checked positions', 'This tool checks only the Birth Day, Life Path compound and optional Expression compound defined in the method below.');
      score('Karmic markers', audit.findings.length ? summary : 'None', audit.findings.length ? 'In checked positions' : 'Not a life verdict');
      score('Life Path', audit.lifePath.value, 'Compound ' + audit.lifePath.final.compound + '/' + audit.lifePath.value);
      score('Birth Day', audit.birthday, KARMIC_DEBTS[audit.birthday] ? 'Debt-number day' : 'No debt marker');
      if (audit.name) score('Expression', audit.name.expression.value, 'Compound ' + audit.name.expression.compound + '/' + audit.name.expression.value);
      show(scores);
      if (audit.findings.length) {
        audit.findings.forEach(function (finding) {
          var item = create('li');
          item.appendChild(create('strong', '', finding.number));
          item.appendChild(create('span', '', finding.position + ': ' + DEBT_COPY[finding.number]));
          debts.appendChild(item);
        });
      } else {
        var empty = create('li');
        empty.appendChild(create('strong', '', '✓'));
        empty.appendChild(create('span', '', 'None of 13, 14, 16 or 19 appeared in the three positions this calculator checks. Other numerology schools may define or calculate karmic themes differently.'));
        debts.appendChild(empty);
      }
      show(debts);
      insight('Use the marker as a prompt', 'A Karmic Debt number is a traditional numerology interpretation, not evidence of wrongdoing, destiny or punishment.');
      insight('Keep the result specific', 'Look for one observable habit connected with ' + focusValue().toLowerCase() + ' and test a more deliberate alternative.');
      show(insights);
      math.textContent = 'Birth Day checked directly: ' + audit.birthday + '. Life Path components: ' + audit.lifePath.month.value + ' + ' + audit.lifePath.day.value + ' + ' + audit.lifePath.year.value + ' = ' + audit.lifePath.total + ' → ' + audit.lifePath.value + (audit.name ? '. Expression reduction: ' + displayTrace(audit.name.expression) + '.' : '. Name-based Expression was not checked.');
      show(math);
      var dob = isoDate(birth);
      var normalizedPart = audit.name ? 'normalized birth name <' + audit.name.normalized + '>; birth date ' + dob : 'birth date ' + dob + '; normalized birth name not provided';
      configureOffer({
        type: 'Karmic Debt Numerology', tool: '/pages/karmic-debt-calculator', prefix: 'kd',
        question: 'What practical pattern should I examine in ' + focusValue().toLowerCase() + ' based on these checked Karmic Debt positions?',
        context: 'Calculation input: ' + normalizedPart + '. Method: Birth Day, Life Path compound, and optional Pythagorean Expression compound checked for 13, 14, 16, and 19.',
        signals: [
          { label: 'Karmic Debt Numbers', value: summary },
          { label: 'Birth Day Compound', value: String(audit.birthday) },
          { label: 'Life Path Compound', value: String(audit.lifePath.final.compound) },
          { label: 'Life Path', value: String(audit.lifePath.value) },
          { label: 'Expression Compound', value: audit.name ? String(audit.name.expression.compound) : 'Not provided' }
        ],
        scope: 'A non-punitive reflection on the explicitly checked compound-number positions and a practical habit to test in the selected focus.',
        confidence: 'Deterministic symbolic check; karmic debt is a tradition-specific belief, not a scientific fact.'
      });
      scrubInputs();
      reveal();
      return true;
    }

    function matrixNode(position, label, value) {
      var archetype = arcana(value);
      var node = create('div', 'ndc__node');
      node.setAttribute('data-position', position);
      node.appendChild(create('span', '', label));
      node.appendChild(create('strong', '', value));
      node.appendChild(create('small', '', archetype[0]));
      matrix.appendChild(node);
    }
    function renderMatrix(birth) {
      var chart = calculateDestinyMatrix(birth.year, birth.month, birth.day);
      var core = arcana(chart.core);
      beginResult('Your 22-energy Destiny Matrix', 'Core Energy ' + chart.core + ' — ' + core[0] + ': ' + core[1] + '.');
      score('Core Energy', chart.core, core[0]);
      score('Love Line', chart.love, arcana(chart.love)[0]);
      score('Money Line', chart.money, arcana(chart.money)[0]);
      score('Talent Line', chart.talent, arcana(chart.talent)[0]);
      show(scores);
      matrixNode('day', 'Day energy', chart.day);
      matrixNode('month', 'Month energy', chart.month);
      matrixNode('core', 'Core energy', chart.core);
      matrixNode('year', 'Year energy', chart.year);
      matrixNode('love', 'Love line', chart.love);
      matrixNode('tail', 'Tail integration', chart.tail[2]);
      matrixNode('money', 'Money line', chart.money);
      matrix.setAttribute('aria-label', 'Destiny Matrix: day ' + chart.day + ', month ' + chart.month + ', year ' + chart.year + ', core ' + chart.core + ', love ' + chart.love + ', money ' + chart.money + ', karmic tail ' + chart.tail.join('-'));
      show(matrix);
      insight('Core archetype', core[0] + ' centers this matrix around ' + core[1] + '. Use that phrase as a question, not a fixed identity.');
      insight('Love and money lines', 'Love Energy ' + chart.love + ' (' + arcana(chart.love)[0] + ') and Money Energy ' + chart.money + ' (' + arcana(chart.money)[0] + ') show two different contexts in which the core pattern can be tested.');
      insight('Karmic tail', chart.tail.join(' → ') + ' is the three-step reflective sequence produced by this method: inherited pattern, active lesson and integration.');
      insight('Talent line', 'Energy ' + chart.talent + ' (' + arcana(chart.talent)[0] + ') is the supporting capacity calculated from Year Energy plus Core Energy.');
      show(insights);
      math.textContent = 'Day ' + birth.day + ' → ' + chart.day + '; month ' + birth.month + ' → ' + chart.month + '; year digits ' + sumDigits(birth.year) + ' → ' + chart.year + '; core (' + chart.day + ' + ' + chart.month + ' + ' + chart.year + ') → ' + chart.core + '; tail ' + chart.tail.join(' → ') + '.';
      show(math);
      currentShareText = 'My Deckaura Destiny Matrix — Core ' + chart.core + ' ' + core[0] + '; Love ' + chart.love + ' ' + arcana(chart.love)[0] + '; Money ' + chart.money + ' ' + arcana(chart.money)[0] + '; Karmic Tail ' + chart.tail.join('-') + '. Reflective numerology, not a prediction.';
      var dob = isoDate(birth);
      configureOffer({
        type: 'Destiny Matrix', tool: '/pages/destiny-matrix-calculator', prefix: 'dm',
        question: 'How do my Core Energy, Love Line, Money Line and Karmic Tail work together in ' + focusValue().toLowerCase() + '?',
        context: 'Calculation input: birth date ' + dob + '. Method: Deckaura 22-energy matrix; values above 22 are reduced by digit sum until 1–22.',
        signals: [
          { label: 'Day Energy', value: String(chart.day) },
          { label: 'Month Energy', value: String(chart.month) },
          { label: 'Year Energy', value: String(chart.year) },
          { label: 'Core Energy', value: String(chart.core) },
          { label: 'Love Line', value: String(chart.love) },
          { label: 'Money Line', value: String(chart.money) },
          { label: 'Karmic Tail', value: chart.tail.join('-') }
        ],
        scope: 'A synthesis of the seven visible Deckaura 22-energy positions, their Major Arcana archetypes and practical reflection prompts for the selected focus.',
        confidence: 'Deterministic Deckaura symbolic matrix; not a standardized or scientifically validated system.'
      });
      scrubInputs();
      reveal();
      return true;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault(); clearErrors();
      var dateInput = field('birth_date');
      var birth = parseDate(dateInput && dateInput.value);
      if (!birth) { invalidate(dateInput, tool === 'name-numerology' ? nameText('errorDate', 'Enter a valid birth date from 1900 through today.') : 'Enter a valid birth date from 1900 through today.'); return; }
      if (tool === 'name-numerology') renderName(field('birth_name').value, birth);
      else if (tool === 'personal-year') {
        var target = Number(field('target_year').value);
        if (!Number.isInteger(target) || target < birth.year || target > 2100) { invalidate(field('target_year'), 'Choose a target year from your birth year through 2100.'); return; }
        renderPersonalYear(birth, target);
      } else if (tool === 'karmic-debt') renderKarmic(field('birth_name').value, birth);
      else if (tool === 'destiny-matrix') renderMatrix(birth);
    });

    reset.addEventListener('click', function () {
      result.hidden = true; offer.hidden = true; currentShareText = ''; clearErrors();
      form.reset();
      var target = field('target_year'); if (target) target.value = root.getAttribute('data-current-year') || String(new Date().getFullYear());
      try { if (global.DeckauraDeepReading && typeof global.DeckauraDeepReading.hide === 'function') global.DeckauraDeepReading.hide(); } catch (_) {}
      var first = form.querySelector('input,select'); if (first) first.focus();
      form.scrollIntoView({ behavior: 'auto', block: 'center' });
    });

    if (share) share.addEventListener('click', function () {
      if (!currentShareText) return;
      if (navigator.share) {
        navigator.share({ title: 'My Deckaura Destiny Matrix', text: currentShareText }).then(function () { shareStatus.textContent = 'Share sheet opened.'; }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(currentShareText).then(function () { shareStatus.textContent = 'Result summary copied.'; }).catch(function () { shareStatus.textContent = 'Copy was unavailable. Select the visible scores to share them.'; });
      } else shareStatus.textContent = 'Select the visible scores to share them.';
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ndc-tool]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})(typeof window !== 'undefined' ? window : globalThis);
